const tabs = document.querySelectorAll(".opening-hours-bar__tabs__tab-headline");

tabs.forEach(function(tab) {
	tab.addEventListener("click", changeTab);
});

function changeTab() {
	const tabIdentifyer = this.dataset.tabnumber;
	tabs.forEach(function(tab) {
		tab.classList.remove("active");
	});
	this.classList.add("active");
	const tabContent = document.querySelectorAll(".opening-hours-bar__content-wrapper__tab-content");
	tabContent.forEach(function(tab) {
		if (tab.dataset.tabcontentnumber == tabIdentifyer) {
			tab.classList.add("active");
		} else {
			tab.classList.remove("active");
		}
	});
}